import React, { useEffect, useState } from 'react'
import './App.css';
import { Container, Grid, Button, Header, Loader, Dimmer, Form, Divider } from 'semantic-ui-react'

import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

import Web3Adapter from './Web3Adapter.js';

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: "c19ff672a85c4706a4a8471e2cefbb91"
    }
  }
};

function App() {

  const [isConnected, setConnection] = useState(false);
  const [web3Adapter, setWeb3Adapter] = useState(false);
  const [remaining, setRemaining] = useState(false)
  const [claimed, setClaimed] = useState("-")
  const [checkClaim, setCheckClaim] = useState(1)
  const [isLoading, setLoader] = useState(false)
  const [amount, setAmount] = useState(1)

  useEffect(() => { }, [])

  const adapterCb = (event, data) => {
    switch (event) {
      case 'connected':
        if (!isConnected) {
          setConnection(true)
        }
        break;;
      case 'purchased':
        setRemaining(data)
        break;;
      case 'claimCheck':
        setClaimed(data)
        break;;
      case 'claimed':
        break;;
      case 'error':
        break;;
      default:
        console.log(data)
    }
    setLoader(false);
  }

  const connect = async () => {
    try {
      if (isConnected) {
        return
      }
      const web3Modal = new Web3Modal({
        providerOptions,
        theme: {
          background: "rgba(39,49,56,0.85)"
        }
      });
      let provider = await web3Modal.connect();
      if (!provider) {
        return;
      }

      let w3Adapter = new Web3Adapter(adapterCb)
      await w3Adapter.init(provider);
      let supply = await w3Adapter.remaining();
      setRemaining(supply)
      setWeb3Adapter(w3Adapter);
    }
    catch (ex) {
      console.log(ex)
    }
  }

  const notConnected = () => {
    connect();
  }

  const handleChange = (event) => {
    setAmount(event.target.value);
  }

  const handleChange2 = (event) => {
    setCheckClaim(event.target.value);
  }

  const tokenClaim = async () => {
    try {
      if (isNaN(checkClaim) || isNaN(parseInt(checkClaim, 10)) || parseInt(checkClaim, 10) > 20 || parseInt(checkClaim, 10) < 0) {
        return
      }
      await web3Adapter.checkClaim(checkClaim);
    }
    catch (ex) {
      console.log(ex)
    }
  }

  const freeClaim = async () => {
    try {

      setLoader(true)
      await web3Adapter.freeClaim(checkClaim);
    }
    catch (ex) {
      console.log(ex)
    }
  }

  const purchase = async () => {

    try {
      if (isNaN(amount) || isNaN(parseInt(amount, 10)) || parseInt(amount, 10) > 20 || parseInt(amount, 10) < 0) {
        return
      }
      setLoader(true)
      await web3Adapter.purchase(amount);
    }
    catch (ex) {
      console.log(ex)
    }
  }
  const connected = () => {
    return (
      <>
        <Container>
          <Grid.Row>
            <Container style={{ background: "#00000082" }} textAlign="center">
              <Grid.Row textAlign="center" centered>
                <p>Skylines Holders</p>
                <Button onClick={() => freeClaim()} color="grey">Free Claim</Button>
              </Grid.Row>
            </Container>
          </Grid.Row>
          <br></br>
          <Divider />
          <Grid.Row>
            <Container style={{ background: "#00000082" }} textAlign="center">
              <Grid.Row textAlign="center" centered>
                <Form style={{ "alignItems": "center", "justifyContent": "center", "display": "flex" }} size="mini">
                  <Form.Field style={{ "alignItems": "center", "width": "25%" }}>
                    <p>Amount</p>
                    <input placeholder="" value={amount} onChange={handleChange} />
                  </Form.Field>
                </Form>
                <Button onClick={() => purchase()} color="grey">Purchase</Button>
              </Grid.Row>
              <br></br>
              <Grid.Row>
                <p>Price: 0.2 ETH</p>
                <p>Max Per Tx: 20</p>
                <p>Remaining: {remaining || remaining == "0" ? remaining : "-"}/1111</p>
              </Grid.Row>
            </Container>
          </Grid.Row>
          <br></br>
          <Divider />
          <Grid.Row>
            <Container style={{ background: "#00000082" }} textAlign="center">
              <Grid.Row textAlign="center" centered>
                <Form style={{ "alignItems": "center", "justifyContent": "center", "display": "flex" }} size="mini">
                  <Form.Field style={{ "alignItems": "center", "width": "25%" }}>
                    <p>Has Skylines Token Used Free Claim?</p>
                    <input placeholder="" value={checkClaim} onChange={handleChange2} />
                  </Form.Field>
                </Form>
                <Button onClick={() => tokenClaim()} color="grey">Check</Button>
              </Grid.Row>
              <br></br>
              <Grid.Row>
                <p>Has Claimed? {claimed === "-" ? "-" : claimed ? "True" : "False"}</p>
              </Grid.Row>
            </Container>
          </Grid.Row>
        </Container>
      </>
    )
  }


  return (
    <Container fluid className="app">
      <Dimmer className="overlay" active={isLoading}>
        <Loader className="overlay" active={isLoading}>Please Wait</Loader>
      </Dimmer>

      <div style={{ "zIndex": "0", "width": "100vw", "height": "100vh", "position": "absolute" }}>
        <iframe id="lfs" width="100%" height="100%" src="https://lofiskylines.mypinata.cloud/ipfs/QmVUjhbhR4rG9vd8BpzfZhDHPDmNPYH8eh7NbVfWAF367i/?seed=badc0ffee" />
      </div>

      <Grid.Row centered className="overlay">
        <Grid.Column className="overlay" style={{ "display": "flex", "alignItems": "center", "padding": "5rem" }} className="frame" width={16}>
          <Header className="overlay" style={{ "color": "#ffffff" }} as='h1'>LoFiStargazer</Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="overlay" centered>
        <Grid.Column className="overlay" style={{ "display": "flex", "alignItems": "center", "padding": "5rem" }} className="frame" width={16}>
          {!isConnected ? notConnected() : connected()}
        </Grid.Column>
      </Grid.Row>
    </Container>
  )

}

export default App;
